// extracted by mini-css-extract-plugin
export default {"profile":"profile_profile__mQV8t"};